export const isMinView = (width = 900) => {
    return window.innerWidth < width;
}

export const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，所以加1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    // const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}.${month}.${day} ${hours}:${minutes}`;
}

export const _trackCustomEvent = (event, property) => {
    if (window._hmt !== undefined) {
        window._hmt.push(['_trackCustomEvent', event, property]);
    }
}
export const _trackEvent = (event, property) => {
    if (window._hmt !== undefined) {
        window._hmt.push(['_trackEvent', event, property]);
    }
}


// WEBPACK FOOTER //
// ./src/utils/index.js